import { useEffect, useRef, useState } from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useDispatch, useSelector } from 'react-redux';
import { clearGeneralInventory } from '../../../../appRedux/actions/Reports';
import { formatPrice } from '../../../../util/formatPrice';
import { formatFileName } from '../../../../util/strings';
import { ExportButton } from '../../../uiComponents/ExportButton';
import { ReportTableHeader } from '../../../uiComponents/ReportTableHeader';
import { generalInventoryReportConst } from '../../../../constants';
import { GeneralInventoryFilter } from '../../ReportFilter/GeneralInventoryFilter';
import { DataNotFound } from '../DataNotFound';

export const GeneralInventoryReport = () => {
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const { generalInventory } = useSelector((state) => state.reports);
  const { fullname, role } = useSelector((state) => state.userAuth);
  const [header, setHeader] = useState([]);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: formatFileName(generalInventoryReportConst.title),
    sheet: generalInventoryReportConst.title,
  });
  const hasData = !!Object.keys(generalInventory).length;
  let total = 0;

  useEffect(() => {
    dispatch(clearGeneralInventory());
  }, [dispatch]);

  useEffect(() => {
    const header = generalInventoryReportConst.header;
    setHeader(header);
  }, [dispatch]);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <ExportButton onDownload={onDownload} disabled={!hasData} />
        <GeneralInventoryFilter />
      </div>

      <div ref={tableRef}>
        {hasData ? (
          <table
            style={{
              overflowX: 'scroll',
              margin: '0 auto',
            }}
          >
            <ReportTableHeader
              user={fullname}
              role={role}
              title={generalInventoryReportConst.title}
              col1={5}
              col2={0}
              col3={10}
            />
            <tbody>
              <tr>
                {header?.map((item, key) => (
                  <th
                    key={key}
                    colSpan={3}
                    style={{ border: '1px solid black', padding: '15px' }}
                  >
                    {item}
                  </th>
                ))}
              </tr>
              {generalInventory?.map((row, key) => {
                total = Number(row.totalAmount) + total;

                return (
                  <tr key={key}>
                    <td
                      colSpan={3}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                      }}
                    >
                      {key + 1}
                    </td>
                    <td
                      colSpan={3}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {row.name}
                    </td>
                    <td
                      colSpan={3}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {formatPrice(row.totalAmount)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  <h4>MONTO TOTAL DE INVENTARIOS</h4>
                </td>
                <td
                  colSpan={3}
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  {formatPrice(total)}
                </td>
              </tr>
            </tfoot>
          </table>
        ) : (
          <DataNotFound />
        )}
      </div>
    </div>
  );
};
